import Vue from 'vue'

import { hashToCamunda } from '@/utils'

export default Vue.extend({
  methods: {
    async saveAndComplete(
      prefix: string,
      save: () => Promise<any>,
      complete: (a: any) => Promise<any>
    ): Promise<any> {
      return save()
        .catch(error => {
          console.log('caught error!', error, error.response)
          if (error!.response!.data!.code === '42501') {
            console.log('rls error')
            return {} // this save was a forbidden by row level security, therefore it was an update, therefore it was previously successful, thus complete.
          } else {
            throw error
          }
        })
        .then(stored => complete(hashToCamunda(stored, prefix)))
    },
  },
})
